
import Vue from "vue";
import AppSidebarAttachmentsBlock from "./SidebarAttachmentsBlock.vue";
import { BrowseStateBase } from "@/utils/browse/browse-state-base";

export default Vue.extend({
	props: {
		item: {
			type: Object as () => any,
			required: true
		},
		state: {
			type: Object as () => BrowseStateBase,
			required: true
		}
	},
	computed: {
		filesItem():any {
			let history:any[] = this.item.History || [];
			let documents:any[] = [];
			for (let event of history) {
				documents.push(...(event.AWSDocuments || []));
			}
			return {AWSDocuments: documents};
		}
	},
	components: {
		AppSidebarAttachmentsBlock
	}
});
